export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["CS_CZ"] = "cs-cz";
    LanguageCode["DA_DK"] = "da-dk";
    LanguageCode["DE_DE"] = "de-de";
    LanguageCode["EN_GB"] = "en-gb";
    LanguageCode["EN_US"] = "en-us";
    LanguageCode["ES_ES"] = "es-es";
    LanguageCode["ET_EE"] = "et-ee";
    LanguageCode["FR_FR"] = "fr-fr";
    LanguageCode["IS_IS"] = "is-is";
    LanguageCode["IT_IT"] = "it-it";
    LanguageCode["JA_JP"] = "ja-jp";
    LanguageCode["LT_LT"] = "lt-lt";
    LanguageCode["LV_LV"] = "lv-lv";
    LanguageCode["NB_NO"] = "nb-no";
    LanguageCode["NL_NL"] = "nl-nl";
    LanguageCode["PL_PL"] = "pl-pl";
    LanguageCode["PT_PT"] = "pt-pt";
    LanguageCode["RO_RO"] = "ro-ro";
    LanguageCode["RU_RU"] = "ru-ru";
    LanguageCode["SV_SE"] = "sv-se";
    LanguageCode["TR_TR"] = "tr-tr";
    LanguageCode["FI_FI"] = "fi-fi";
})(LanguageCode || (LanguageCode = {}));
export var Gender;
(function (Gender) {
    Gender["Female"] = "female";
    Gender["Male"] = "male";
})(Gender || (Gender = {}));
export var CallPattern;
(function (CallPattern) {
    CallPattern["FirstToPickUp"] = "first_to_pick_up";
    CallPattern["Sequence"] = "sequence";
})(CallPattern || (CallPattern = {}));
